export class LoginAsPermission {
    public id: number | null;
    public role_id: number | null;
    public bussiness_line_id: number;
    public name: string;

    constructor(data: LoginAsPermissionData | void) {
        if (data === undefined) {
            this.id = null;
            this.role_id = null;
            this.bussiness_line_id = -1;
            this.name = "";
        } else {
            this.id = data.id;
            this.role_id = data.role_id;
            this.bussiness_line_id = data.bussiness_line_id;
            this.name = data.name;
        }
    }

    public resetToDefaults(): void {
        this.id = null;
        this.role_id = null;
        this.bussiness_line_id = -1;
        this.name = '';
    }

    public serializeData(): LoginAsPermissionData {
        return {
            id: this.id,
            name: this.name,
            role_id: this.role_id,
            bussiness_line_id: this.bussiness_line_id,
        };
    }
}

export type LoginAsPermissionData = {
    id: number | null;
    role_id: number | null;
    bussiness_line_id: number;
    name: string;
}